<template>
  <el-row>
    <el-tabs
      v-model="tabsKey"
      type="card"
      closable
      @tab-remove="removeTabs"
      @tab-click="selectTabsfunc(tabsKey)"
    >
      <el-tab-pane
        v-for="item in this.$store.state.tabs"
        :key="item.name"
        :label="item.title"
        :name="item.name"
      >
        <sepa-add-specifications
          v-if="item.name === 'sepa-add-specifications'"
        ></sepa-add-specifications>
        <remoteList
          v-if="item.name === 'remoteList'"
        ></remoteList>
        <methods
          v-if="item.name === 'methods'"
        ></methods>
      </el-tab-pane>
    </el-tabs>
  </el-row>
</template>

<script>
import SepaAddSpecifications from '@/components/separate_methods/SepaAddSpecifications.vue'
import RemoteList from '@/components/separate_methods/RemoteList.vue'
import Methods from '@/components/separate_methods/Methods.vue'
export default {
  name: 'HeaderTabs',
  components: {
    SepaAddSpecifications,
    RemoteList,
    Methods,
  },
  methods: {
    removeTabs: function(targetName) {
      this.$store.commit('updateTabs', {
        tag: 'remove',
        targetName: targetName,
      })
      // window.location.reload()
    },
    selectTabsfunc: function(tabsKey) {
      // console.log(tabsKey);
      this.$store.commit('updateTabsKey', tabsKey)
    },
  },
  computed: {
    tabsKey: {
      get() {
        return this.$store.state.tabsKey
      },
      set(tabsKey) {
        this.$store.commit('updateTabsKey', tabsKey)
      },
    },
  },
}
</script>

<style scoped></style>
